import { useState, useCallback, useEffect } from 'react';

export const useIsMobile = (maxWidth?:Number, maxWidthTablet?:Number) => {
  const [targetReached, setTargetReached] = useState(false);
  const [targetReachedTablet, setTargetReachedTablet] = useState(false);

  const updateTarget = useCallback((e:any) => {
    if (e.matches) {
      setTargetReached(true);
    } else {
      setTargetReached(false);
    }
  }, []);
  const updateTargetTablet = useCallback((e:any) => {
    if (e.matches) {
      setTargetReachedTablet(true);
    } else {
      setTargetReachedTablet(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const media = window.matchMedia(`(max-width: ${maxWidth || 768}px)`);
    const mediaTablet = window.matchMedia(`(min-width:768px) and (max-width: ${maxWidthTablet || 1024}px)`);
    media.addEventListener('change', updateTarget);
    mediaTablet.addEventListener('change', updateTargetTablet);

    // Check on mount (callback is not called until a change occurs)
    if (media.matches) {
      setTargetReached(true);
    }
    if (mediaTablet.matches) {
      updateTargetTablet(true);
    }

    return () => {
      media.addEventListener('change', updateTarget);
      mediaTablet.addEventListener('change', updateTargetTablet);
    };
  }, []);
  return {
    isMobile: targetReached,
    isTablet: targetReachedTablet,
  };
};
